export const SERVICE_ID = {
    IAMTEACHER: 'IAMTEACHER',

    //잘못된 서비스 아이디로 접근했을 떄
    EMPTY_SERVICE_ID: 'EMPTY_SERVICE_ID',
};

export const PAGE_TYPE = {
    EDITOR: 'EDITOR',
    RESPONSE: 'RESPONSE',
    EMPLOYEE_RESPONSE: 'EMPLOYEE_RESPONSE',
    EMPTY_TYPE: 'EMPTY_TYPE',

    CORONA_RESPONSE: 'CORONA_RESPONSE',
};

export const SERVICE_IDS = [SERVICE_ID.IAMTEACHER];

export function getAssetInfo(serviceId, type) {
    serviceId = serviceId.toUpperCase();
    type = type.toUpperCase();

    if (serviceId === SERVICE_ID.IAMTEACHER) {
        if (type === PAGE_TYPE.EDITOR) {
            return {
                css: [
                    import(/* webpackChunkName: "css-iamteacher-editor" */'@/iamteacherpc/assets/common/css/tui-date-picker.css'),
                    import(/* webpackChunkName: "css-iamteacher-editor" */'@/iamteacherpc/assets/iamteacher/editor/css/common.css'),
                    import(/* webpackChunkName: "css-iamteacher-editor" */'@/iamteacherpc/assets/iamteacher/editor/css/contents.css'),
                    import(/* webpackChunkName: "css-iamteacher-editor" */'@/iamteacherpc/assets/iamteacher/editor/css/custom.css'),
                    import(/* webpackChunkName: "css-iamteacher-editor" */'@/iamteacherpc/assets/iamteacher/editor/css/custom-id.css'),
                ]
            }
        }

        if (type === PAGE_TYPE.RESPONSE) {
            return {
                css: [
                    import(/* webpackChunkName: "css-iamteacher-response" */'@/iamteacherpc/assets/iamteacher/response/css/survey.css'),
                    import(/* webpackChunkName: "css-iamteacher-response" */'@/iamteacherpc/assets/iamteacher/response/css/survey_app_notice.css'),
                    import(/* webpackChunkName: "css-iamteacher-response" */'@/iamteacherpc/assets/iamteacher/response/css/custom.css'),
                    import(/* webpackChunkName: "css-iamteacher-response" */'@/iamteacherpc/assets/iamteacher/response/css/lang-id-custom.css'),
                ],
                assets: {
                    loading: import(/* webpackChunkName: "css-iamteacher-response" */'@/iamteacherpc/assets/iamteacher/response/img/loader.svg'),
                    loadingB: import(/* webpackChunkName: "css-iamteacher-response" */'@/iamteacherpc/assets/iamteacher/response/img/loader_b.svg'),
                }
            }
        }

        if (type === PAGE_TYPE.EMPLOYEE_RESPONSE) {
            return {
                css: [
                    import(/* webpackChunkName: "css-iamteacher-app-employee-response" */'@iamteacherapp/assets/iamteacher/employeeResponse/css/survey.css'),
                    import(/* webpackChunkName: "css-iamteacher-app-employee-response" */'@iamteacherapp/assets/iamteacher/employeeResponse/css/survey_app_notice.css'),
                    import(/* webpackChunkName: "css-iamteacher-app-employee-response" */'@iamteacherapp/assets/iamteacher/employeeResponse/css/custom.css'),
                    import(/* webpackChunkName: "css-iamteacher-app-employee-response" */'@iamteacherapp/assets/iamteacher/employeeResponse/css/lang-id-custom.css'),
                ],
                assets: {
                    loading: import(/* webpackChunkName: "css-iamteacher-app-employee-response" */'@iamteacherapp/assets/iamteacher/employeeResponse/img/loader.svg'),
                    loadingB: import(/* webpackChunkName: "css-iamteacher-app-employee-response" */'@iamteacherapp/assets/iamteacher/employeeResponse/img/loader_b.svg'),
                }
            }
        }

        if (type === PAGE_TYPE.CORONA_RESPONSE) {
            return {
                css: [
                    import(/* webpackChunkName: "css-iamteacher-corona-response" */'@/iamteacherpc/assets/iamteacher/coronaResponse/css/m.css'),
                    import(/* webpackChunkName: "css-iamteacher-corona-response" */'@/iamteacherpc/assets/iamteacher/coronaResponse/css/custom.css'),
                ],
                assets: {
                    loading: import(/* webpackChunkName: "css-iamteacher-corona-response" */'@/iamteacherpc/assets/iamteacher/coronaResponse/img/loader.svg'),
                }
            }
        }
    }

    if (serviceId === SERVICE_ID.EMPTY_SERVICE_ID) {
        return {
            css: []
        }
    }
}

export function getComponentInfo(serviceId, type) {
    serviceId = serviceId.toUpperCase();
    type = type.toUpperCase();
    if (serviceId === SERVICE_ID.IAMTEACHER) {
        if (type === PAGE_TYPE.RESPONSE) {
            return {
                headerComponent: import(/* webpackChunkName: "component-iamteacher-response" */'@/iamteacherpc/components/services/iamteacher/ResponseHeader.vue')
            }
        }
    }
}
